import { Environments } from "@movinglayers/environment";

export const environment = {
  production: false,
  environment: 'dev' as Environments,
  message: 'Building for DEV environment',
  SERVER_URL: 'https://hob-dev.movinglayers.eu',
  SERVER_PORT: '443',
  BACKEND_URL: 'https://vts-dev-be.movinglayers.eu',
  BACKEND_PORT: '443',
  OTA_VERSION_URL: '',
  BUILD_VERSION: 'BUILD_VERSION_CI' //Replaced by CI to something like v0.0.1
}
